import { withLayout } from "../../components/feature/PageLayout";
import SEOHead from "../../components/feature/SEOHead";

const siteUrl = (import.meta.env.VITE_SITE_URL || "").replace(/\/+$/, "");

const socialLinks = [
  {
    href: "https://line.me/R/ti/p/@your-id",
    icon: "ri-line-line",
    label: "LINE 官方帳號",
  },
  {
    href: "https://www.facebook.com/groups/your-group",
    icon: "ri-facebook-line",
    label: "FB 社團",
  },
  {
    href: "https://www.instagram.com/your-handle",
    icon: "ri-instagram-line",
    label: "Instagram",
  },
  {
    href: "https://www.youtube.com/@your-handle",
    icon: "ri-youtube-line",
    label: "YouTube",
  },
  {
    href: "https://www.tiktok.com/@your-handle",
    icon: "ri-tiktok-line",
    label: "TikTok",
  },
  {
    href: "https://www.threads.net/@your-handle",
    icon: "ri-threads-line",
    label: "Threads",
  },
];

function Contact() {
  return (
    <>
      <SEOHead
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ContactPage",
          "name": "聯繫我 / 加入團隊｜香氛女王的幸福大地",
          "description": "加入 LINE 官方社群、預約免費諮詢、了解 90 天啟動與團隊加入方式。"
        }}
      />
      {/* Hero */}
      <section className="relative w-full h-[380px] md:h-[520px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20inviting%20scene%20of%20two%20women%20having%20a%20meaningful%20conversation%20in%20a%20beautiful%20airy%20room%2C%20essential%20oil%20diffuser%20and%20tea%20on%20a%20wooden%20table%2C%20soft%20golden%20sunlight%2C%20cream%20and%20amber%20tones%2C%20coaching%20and%20mentoring%20atmosphere%2C%20feminine%20connection%20photography&width=1800&height=900&seq=contact-hero-bg&orientation=landscape"
          alt="聯繫我 / 加入團隊"
          title="香氛女王的幸福大地 聯繫我加入團隊"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
        <div className="relative z-10 w-full max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h1 className="text-[2rem] md:text-[2.75rem] font-bold text-white leading-[1.3] mb-3 md:mb-4">
            讓我成為妳的人生香氣導師，免費諮詢從這裡開始
          </h1>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] max-w-[680px] mx-auto mb-5">
            我以香氣 × 系統 × 領導力陪妳完成 90
            天啟動。選擇下方行動：加入團隊，或申請一對一教練。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 flex-wrap">
            <a
              href="https://forms.gle/your-google-form"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
            >
              我要加入團隊（Google Form）
            </a>
            <a
              href="https://line.me/R/ti/p/@your-id"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-white text-white hover:bg-white/15 transition-colors duration-200"
            >
              我要加入團隊（LINE@）
            </a>
            <a
              href="#contact-form"
              className="inline-flex items-center justify-center px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-white text-primary-500 hover:bg-primary-100 transition-colors duration-200"
            >
              申請一對一諮詢
            </a>
          </div>
        </div>
      </section>

      {/* Contact Form + Social */}
      <section className="py-14 md:py-20 bg-background-50" id="contact-form">
        <div className="max-w-[1120px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12">
            {/* Form */}
            <div className="lg:w-[60%]">
              <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-foreground-950 leading-[1.4] mb-2">
                聯絡表單
              </h2>
              <p className="text-[1.1875rem] text-foreground-600 leading-[1.75] mb-6">
                留下資料，我將回覆諮詢時段與加入方式。
              </p>
              <form
                data-readdy-form
                action="https://readdy.ai/api/form/d8pdsevij7vns5otj8rg"
                method="POST"
                className="space-y-4"
              >
                <div>
                  <label
                    htmlFor="contact-name"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    姓名
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="請輸入您的姓名"
                  />
                </div>
                <div>
                  <label
                    htmlFor="contact-email"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    Email
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors"
                    placeholder="請輸入您的 Email"
                  />
                </div>
                <div>
                  <label
                    htmlFor="contact-topic"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    諮詢主題
                  </label>
                  <select
                    id="contact-topic"
                    name="topic"
                    required
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 focus:outline-none focus:border-primary-500 transition-colors cursor-pointer appearance-none"
                  >
                    <option value="">請選擇</option>
                    <option value="加入團隊/90天啟動">
                      加入團隊 / 90 天啟動
                    </option>
                    <option value="一對一教練">一對一教練</option>
                    <option value="課程報名/方案建議">
                      課程報名 / 方案建議
                    </option>
                    <option value="其他合作/演講邀請">
                      其他合作 / 演講邀請
                    </option>
                  </select>
                </div>
                <div>
                  <label
                    htmlFor="contact-message"
                    className="block text-[1rem] font-medium text-foreground-950 mb-1.5"
                  >
                    想說的話{" "}
                    <span className="text-foreground-600 font-normal">
                      （選填）
                    </span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-[18px] border border-background-300 bg-white text-[1rem] text-foreground-950 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500 transition-colors resize-none"
                    placeholder="歡迎留下您想說的話"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-8 py-3.5 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
                >
                  送出表單
                </button>
              </form>
            </div>
            {/* Social Side */}
            <div className="lg:w-[40%]">
              <div className="bg-secondary-500 rounded-[18px] p-6 md:p-8">
                <h3 className="text-[1.375rem] font-semibold text-white mb-2">
                  我們的社群
                </h3>
                <p className="text-[1rem] text-white/70 leading-[1.6] mb-5">
                  追蹤最新課程、直播與學員故事。
                </p>
                <div className="space-y-2.5 mb-6">
                  {socialLinks.map((social) => (
                    <a
                      key={social.label}
                      href={social.href}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="flex items-center gap-3 py-2.5 px-4 rounded-[12px] text-white hover:bg-white/10 transition-colors duration-200 cursor-pointer"
                    >
                      <i className={`${social.icon} text-[1.25rem]`}></i>
                      <span className="text-[1rem] leading-[1.5]">
                        {social.label}
                      </span>
                    </a>
                  ))}
                </div>
                <div className="border-t border-white/15 pt-5">
                  <p className="text-[1rem] text-white/75 leading-[1.6] mb-4">
                    一鍵加 LINE 👉 線上說明會、教學與活動第一時間通知
                  </p>
                  <a
                    href="https://line.me/R/ti/p/@your-id"
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
                  >
                    加 LINE 好友 <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="relative py-16 md:py-24 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Inspiring%20sunrise%20scene%20with%20a%20woman%20standing%20looking%20at%20the%20horizon%2C%20warm%20golden%20morning%20light%2C%20fields%20of%20lavender%20in%20the%20distance%2C%20new%20beginning%20and%20hope%20vibe%2C%20cream%20and%20amber%20tones%2C%20cinematic%20landscape%20with%20soft%20focus&width=1800&height=700&seq=contact-cta-bg&orientation=landscape"
          alt="行動，從現在開始"
          title="行動從現在開始"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
        <div className="relative z-10 max-w-[1120px] mx-auto px-4 md:px-6 text-center">
          <h2 className="text-[1.5rem] md:text-[2.125rem] font-bold text-white leading-[1.4] mb-3">
            行動，從現在開始
          </h2>
          <p className="text-[1.1875rem] text-white/80 leading-[1.75] mb-6 max-w-[640px] mx-auto">
            選擇加入團隊或申請一對一教練，讓我陪妳完成第一個 90 天的改變。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://line.me/R/ti/p/@your-id"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer bg-primary-500 text-white hover:bg-primary-600 transition-colors duration-200"
            >
              加入 LINE@
            </a>
            <a
              href="https://forms.gle/your-google-form"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center justify-center px-7 py-3 rounded-full text-[1.0625rem] font-medium whitespace-nowrap cursor-pointer border-2 border-white text-white hover:bg-white/15 transition-colors duration-200"
            >
              填寫 Google Form
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default withLayout(Contact);